import { useMemo } from 'react';

declare global {

    interface Window {
        __host: {
            [key: string]: any,
        };
    }
}

export const getHostProperty = <T>(prop: string): T | undefined => {
    if (typeof window === 'undefined') return undefined;
    // eslint-disable-next-line no-underscore-dangle
    const host = window.__host;
    const all = (typeof host === 'string' ? JSON.parse(host) : host) as Record<string, any>;
    return all?.[prop];
};

export const useHostProperty = <T>(prop: string): T =>
    useMemo(() => getHostProperty<T>(prop) as T, [prop]);
